export const asRecord = (value: unknown): Record<string, unknown> | null => {
  if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }
  return null;
};

export const pickStr = (
  obj: Record<string, unknown>,
  camel: string,
  snake: string
): string | null => {
  const a = obj[camel];
  const b = obj[snake];
  const v = a !== undefined && a !== null ? a : b;
  if (v === undefined || v === null) return null;
  return String(v);
};

export const pickNum = (
  obj: Record<string, unknown>,
  camel: string,
  snake: string
): number | undefined => {
  const a = obj[camel];
  const b = obj[snake];
  const v = a !== undefined && a !== null ? a : b;
  if (v === undefined || v === null) return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
};
